import apiCall from '../../utility/api';
import { fetchdartTemplateList, fetchDartDetails, fetchJsonSchema, fetchAutomationList, fetchAutomationListCnt, deleteAutomation, addAutomation, editAutomation, type, getDartDetails, getAutomationListCnt, fetchExportData, duplicateAutomationFunc, importData, validateAutomationName } from './automation_common_func';

type dataProps = {
  setSelectedRowIdInTable: any;
  exportBtnClicked: boolean;
  setExportBtnClicked: any;
  setExportDetails: any;
  exportDetails?: any;
  rowID: number;
  tenant: string;
  newData?: any;
  dropdownData: null;
  saveBtnClicked: any;
  setSaveBtnClicked: any;
  setOverlayOpen: any;
  setErrorToast: any;
  selectedRowIdInTable: any;
  setToastMessage: any;
  setIsToast: any;
  data: any;
  func: any;
  searchVal: string;
  pageNo: number;
  setTotalPages: any;
  setTotalRecords: any;
  setDartSpecs?: any;
  setJsonData?: any;
  setUiData?: any;
  deleteAutomation: boolean;
  setDeleteAutomation: any;
  setDeleteDisabled: any;
  isRefresh: boolean;
  setRefresh: any;
  setRefreshToast?: any;
  isFilter?: boolean
  dropDownValue1?: string;
  setIsFilter?: any;
  dropdownValue2?: string;
  pageName?: string;
  filterArray?: number[];
  dartToShow?: string;
  dartNo: number;
  overlayName: string;
  formData?: any;
  setFormData?: any;
  setDartTemplatesList: any;
  setLoading?: any;
  setDuplicateAutomation?: any,
  setIsDuplicateDisabled?: any;
  duplicateAutomation?: any
  csvAutomationList?: any;
  setCsvAutomationList?: any;
  setDataInserted?: any;
  setOverlayOpenNew?: any;
  setCurrentPageNo?: any;
  setSearchVal?: any;
  setImportAutomations?: any;
  importAutomations?: any;
  setAllAutomationDetails?: any;
  allAutomationDetails?: any;
  setSubmitDisabled?: any;
  automationName?: any;
  setClassificationNameValidation?: any;
  setAutomationName?: any;
  setAutomationNameInEditForm?: any;
  dropDownValue?: any;
  setIsDisabled?: any
  setIsDynamicToast?: any;
  isDynamicToast?: any;
  setMessage?: any;
  setIsImportProgressLoading?: any;
  setIsCommonToast?: any;
  initialDefaultValue?: any;
  setSpinnerLoad?: any;
}


const automationConfiguration = async (props: dataProps) => {
  console.log("automationconf called");
  
  const dartNo = props.dartNo;

  const getAutomationList = async (whereCondition: any, limit: number | null = null, offset: number | null = null) => {
    try {
      const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

      if (status === 'success' && data.length > 0) {
        if (props.overlayName === 'editAutomation') {
          props.setFormData({
            name: data[0]?.automationName,
            description: data[0]?.description,
            jsonData: JSON.parse(data[0]?.jsonValue)
          });
          props.setSpinnerLoad(false);
          // props.setClassificationNameValidation(true);
          props.setAutomationName(data[0]?.automationName);
          props.setAutomationNameInEditForm(data[0]?.automationName);
        } else {
          props.setLoading(true);
          props.func(data);
        }
      } else {
        props.func([]);
      }
    } catch (error) {
      console.log("getAutomationList error=", error);
      props.func([]);
    }
  }

  const getExportData = async (condition: object) => {
    const { data, status } = await fetchExportData(condition);

    if (status === 'success') {
      props.setExportDetails && props.setExportDetails(data);
    }
    props.setExportBtnClicked(false);
  }

  const getJsonSchema = async (dartid: number) => {
    props.setIsDisabled(true);
    try {
      const { data, status } = await fetchJsonSchema(dartid);

      if (status === 'success' && data.length > 0) {
        const uiSchema = JSON.parse(data[0]?.uiSchema);
        const jsonSchemaData = JSON.parse(data[0]?.jsonSchema);

        uiSchema["ui:submitButtonOptions"] = { "norender": true };

        data[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
        data[0]?.uiSchema != undefined && props.setUiData(uiSchema);
        props.setIsDisabled(false);
      } else {
        props.setJsonData({});
        props.setUiData({});
      }
    } catch (error) {
      console.log("getJsonSchema error=", error);
      props.setJsonData({});
      props.setUiData({});
    }
  };

  const getDartTemplateList = async (whereCondition: any) => {
    try {
      const { data, status } = await fetchdartTemplateList(whereCondition);

      if (status === 'success') {
        props.setDartTemplatesList(data);
      }
    } catch (error) {
      console.log("getdartTemplateList error=", error);
    }
  };

  const deleteUnattachedAutomation = async (ids: number[]) => {
    try {
      const { data, status } = await deleteAutomation(ids, props.dartToShow === "data_collection" ? "default_dart" : 'automation', props.tenant);

      if (status === 'success' && data.affected_rows > 0) {
        props.setIsToast(true);

        getAutomationList({ types: props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation' }, 50, props.pageNo);
      } else {
        props.setToastMessage(`${props.selectedRowIdInTable.length < 2 ? 'Automation' : 'Automations'} deletion failed`);
        props.setErrorToast(true);
      }

      props.setDeleteDisabled(true);
      props.setDeleteAutomation(false);
      props.setSelectedRowIdInTable([]);
    } catch (error) {
      props.setDeleteDisabled(true);
      props.setDeleteAutomation(false);
      props.setSelectedRowIdInTable([]);

      props.setToastMessage(`${props.selectedRowIdInTable.length < 2 ? 'Automation' : 'Automations'} deletion failed`);
      props.setErrorToast(true);
    }
  }

  const createAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, types: string, tenant: string) => {
    try {
      const { status } = await addAutomation(automationName, description, jsonVal, dartid, types, tenant);

      if (status === 'success') {
        props.setIsToast(true);
        props.setOverlayOpen(false);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);

        getAutomationList({ dartid: dartNo, types: props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation' }, 50, props.pageNo);
      } else {
        props.setToastMessage(`${automationName} automation creation failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      console.log("createAutomation error=", error);
      props.setToastMessage(`${automationName} automation creation failed`);
      props.setErrorToast(true);
    }
  }

  const cloneAutomations = async (ids: number[]) => {
    try {
      const { data, status } = await duplicateAutomationFunc(ids, props.dartToShow === "data_collection" ? "default_dart" : 'automation', props.tenant);

      if (status === 'success' && data.affected_rows > 0) {
        props.setIsToast(true);

        getAutomationList({ types: props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation' }, 50, props.pageNo);
      } else {
        props.setToastMessage(`${props.selectedRowIdInTable.length < 2 ? 'Automation' : 'Automations'} duplication failed`);
        props.setErrorToast(true);
      }

      props.setIsDuplicateDisabled(true);
      props.setDuplicateAutomation(false);
      props.setSelectedRowIdInTable([]);
    } catch (error) {
      props.setIsDuplicateDisabled(true);
      props.setDuplicateAutomation(false);
      props.setSelectedRowIdInTable([]);

      props.setToastMessage(`${props.selectedRowIdInTable.length < 2 ? 'Automation' : 'Automations'} duplication failed`);
      props.setErrorToast(true);
    }
  }

  const modifyAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, id: number, tenant: string) => {
    try {
      const type = (dartid === 161 || dartid === 296 || dartid === 176 || dartid === 225) ? 'app policy' : 'automation';

      const res = await editAutomation(automationName, description, jsonVal, dartid, id, tenant, type);

      if (res.status === 'success') {
        props.setOverlayOpen(false);
        props.setIsToast(true);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);

        getAutomationList({ dartid: dartNo, types: props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation' }, 50, props.pageNo);
      } else if (res.status === 'failed') {
        props.setToastMessage("This automation can't be edited as it is already configured");
        props.setErrorToast(true);
        props.setOverlayOpen(false);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);
      } else {
        props.setToastMessage(`Error occured while saving ${automationName} automation`);
        props.setErrorToast(true);
        props.setOverlayOpen(false);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);
      }
    } catch (error) {
      console.log("modifyAutomation error=", error);

      props.setToastMessage(`Error occured while saving ${automationName} automation`);
      props.setErrorToast(true);
      props.setOverlayOpen(false);
      setTimeout(() => {
        props.setSaveBtnClicked(false);
      }, 1000);
    }
  }

  const insertAutomationData = async () => {
    if (props.csvAutomationList.length > 0) {
      console.log('props.csvAutomationList ->', props.csvAutomationList);
      const cleanedList = [
        props.csvAutomationList[0],
        ...props.csvAutomationList.slice(1).filter(row => row.length > 0 && row.some(cell => cell !== ''))
      ];
      try {
        const resp = await importData(cleanedList);
        if (resp.status === 'success') {
          props.setMessage({ type: 'success', text: resp.msg });
          props.setDataInserted(true);
          props.setImportAutomations(false);
          props.setIsImportProgressLoading(false);
          props.setCsvAutomationList([]);
          props.setSubmitDisabled(false);
          console.log("Data inserted successfully");
          props.setOverlayOpenNew(false);
          props.setIsCommonToast(true);
          setTimeout(() => {
            props.setIsCommonToast(false);
          }, 3000);
        } else {
          // props.setMessage({ type: 'error', text: resp.msg });
          props.setIsImportProgressLoading(false);
          console.error("Error inserting automation data:", resp.msg);
          props.setMessage({ type: 'error', text: resp.msg });
          props.setOverlayOpenNew(false);
          props.setImportAutomations(false);
          props.setIsImportProgressLoading(false);
          props.setCsvAutomationList([]);
          props.setSubmitDisabled(false);
          props.setIsCommonToast(true);
          setTimeout(() => {
            props.setIsCommonToast(false);
          }, 3000);
        }
      } catch (error) {
        props.setMessage({ type: 'error', text: 'Automation import failed!' });
        props.setIsImportProgressLoading(false);
        props.setIsCommonToast(true);
        setTimeout(() => {
          props.setIsCommonToast(false);
        }, 3000);
        props.setImportAutomations(false);
        props.setIsImportProgressLoading(false);
        props.setCsvAutomationList([]);
        props.setSubmitDisabled(false);
        console.error("Error inserting automation data:", error);
        // props.setMessage({ type: 'error', text: 'Automation insertion failed!' });
        props.setOverlayOpenNew(false);
      }
    }
  };

  if (!(props.saveBtnClicked) && props.dropdownData === null) {
    getDartTemplateList({ display: "yes", category: props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "data_collection" : 'automation' });
  }

  if (!(props.saveBtnClicked && props.overlayName !== '') && props.isRefresh === false && props.deleteAutomation === false && props.dropdownData !== null && dartNo !== 0 && props.searchVal?.length === 0 && !props.isFilter && (props?.automationName?.length === 0 || props.dartToShow === "registry")) {
    getJsonSchema(dartNo);
    getDartDetails(dartNo, props.setDartSpecs);
  }

  //   console.log("props.dropDownValue=", props.dropDownValue);

  //   if(props.dropDownValue!=='' && props?.pageName !== 'all-automation'){
  //     getJsonSchema(dartNo);
  //     getDartDetails(dartNo, props.setDartSpecs);
  // }

  if (props?.pageName === 'all-automation' && props.searchVal?.length > 0) {
    getAutomationList({ search: props.searchVal, types: ['selfhelp', 'proactive', 'automation', 'usersurvey', 'autoheal', 'scheduler', 'Selfhelp'], function: 'search' }, 50, props.pageNo);
    getAutomationListCnt({ search: props.searchVal, types: ['selfhelp', 'proactive', 'automation', 'usersurvey', 'autoheal', 'scheduler', 'Selfhelp'], function: 'search' }, props.setTotalRecords, props.setTotalPages);
  } else if (props?.pageName === 'all-automation' && props.isFilter === true) {
    console.log("filter function", props.filterArray);
    getAutomationList({ filter: props.filterArray, types: ['selfhelp', 'proactive', 'automation', 'usersurvey', 'autoheal', 'scheduler', 'Selfhelp'], function: 'filter' }, 50, props.pageNo);
    getAutomationListCnt({ filter: props.filterArray, types: ['selfhelp', 'proactive', 'automation', 'usersurvey', 'autoheal', 'scheduler', 'Selfhelp'], function: 'filter' }, props.setTotalRecords, props.setTotalPages);
  } else if (props?.pageName !== 'all-automation' && props.searchVal?.length > 0 && props.searchVal !== '' && props.overlayName === '') {
    getAutomationList({ search: props.searchVal, "types": props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation', function: 'search' }, 50, props.pageNo);
    getAutomationListCnt({ search: props.searchVal, "types": props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation', function: 'search' }, props.setTotalRecords, props.setTotalPages);
  } else if (props.isFilter === true) {
    getAutomationList({ filter: props.filterArray, "types": props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation', function: 'filter' }, 50, props.pageNo);
    getAutomationListCnt({ filter: props.filterArray, "types": props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation', function: 'filter' }, props.setTotalRecords, props.setTotalPages);
  } else if (props.deleteAutomation && props.selectedRowIdInTable.length > 0) {
    deleteUnattachedAutomation(props.selectedRowIdInTable);
  } else if (props.duplicateAutomation && props.selectedRowIdInTable.length > 0) {
    cloneAutomations(props.selectedRowIdInTable);
  } else if (props.saveBtnClicked && props.newData !== undefined && Object.keys(props.newData).length > 0) {

    props.overlayName === 'addAutomation' && createAutomation(props.newData.name, props.newData.description, props.newData.jsonData, dartNo, props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation', props.tenant);
    props.overlayName === 'editAutomation' && modifyAutomation(props.newData.name, props.newData.description, props.newData.jsonData, dartNo, props.rowID, props.tenant);
  } else if (!(props.saveBtnClicked) && props.overlayName === 'editAutomation' && props?.automationName?.length === 0) {
    getAutomationList({ dartid: dartNo, id: props.rowID, types: props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation' }, 0, null);
  } else if (props.exportBtnClicked) {
    const type = (props.pageName === 'all-automation') ? ['selfhelp', 'proactive', 'automation', 'autoheal', 'Selfhelp'] : props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation';

    getExportData({ types: type, function: 'export', tenant: props.tenant });
  } else if (props.importAutomations) {
    insertAutomationData();
  } else if (props?.automationName?.length > 0 && props?.overlayName?.length > 0) {
    props?.automationName !== props.initialDefaultValue?.name && validateAutomationName({ "tenant": props.tenant, function: 'validate', automation: props.automationName, types: props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation' }, props.setClassificationNameValidation);
  } else {
    if (props.pageName === 'all-automation') {
      getAutomationList({ types: ['selfhelp', 'proactive', 'automation', 'usersurvey', 'autoheal', 'scheduler', 'Selfhelp'] }, 50, props.pageNo);
      getAutomationListCnt({ types: ['selfhelp', 'proactive', 'automation', 'usersurvey', 'autoheal', 'scheduler', 'Selfhelp'] }, props.setTotalRecords, props.setTotalPages);
    } else {
      props.overlayName !== 'addAutomation' && getAutomationList({ types: props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation' }, 50, props.pageNo);

      props.overlayName !== 'editAutomation' && getAutomationListCnt({ types: props.dartToShow === "registry" ? 'app policy' : props.dartToShow === "data_collection" ? "default_dart" : 'automation' }, props.setTotalRecords, props.setTotalPages);
    }
  }
}

export { automationConfiguration }